function l(f, u) {
  let e;
  for (const n of f)
    n != null && (e > n || e === void 0 && n >= n) && (e = n);
  return e;
}
export {
  l as default
};
